// extracted by mini-css-extract-plugin
export var getStarted = "index-module--getStarted--QY7VZ";
export var getStarted__button = "index-module--getStarted__button--G6uiV";
export var getStarted__animation = "index-module--getStarted__animation--dISRj";